import React from "react";
import { Link } from "react-router-dom";
import { login } from "./index";
function Login() {
  return (
    <div>
      <div className="container m-auto max-w-full h-screen flex flex-col ">
        <div className="w-[1200px] h-[1200px] blur-3xl box-content fixed top-[500px] left-[-400px] z-[-1] rounded-full bg-darkblue "></div>
        <div className="w-[1200px] h-[1200px] blur-3xl box-content fixed top-[400px] left-[800px]  z-[-2] rounded-full bg-blue "></div>
        <form className="login-form md:m-auto m-[5%] h-fit py-10 md:max-w-6xl max-w-[100%] shadow-2xl rounded-xl flex flex-col items-center bg-white">
          <div className="w-full p-5 bg-blue text-white md:text-5xl text-4xl text-center rounded-t-xl">
            Login
          </div>
          <div className="md:w-[600px] w-[100%] px-8 flex flex-col">
            <label for="regno" className="md:text-3xl text-xl p-5 px-0">
              College Registration Number
            </label>
            <input
              id="regno"
              className="p-5 rounded-xl border-2 outline-none md:text-xl text-lg border-blue text-black"
              name="regno"
              type="text"
              placeholder="For example: 2020BCS0001"
              pattern="\d{4}[A-Za-z]{3}\d{4}"
              required
              autoFocus
            />

            <label for="password" className="md:text-3xl text-xl p-5 px-0">
              Password
            </label>
            <input
              id="password"
              className="p-5 rounded-xl border-2 outline-none md:text-xl text-lg border-blue text-black"
              name="password"
              type="password"
              placeholder="Enter your password here..."
              required
            />
          </div>
          <div className="flex flex-col items-center">
            <input
              type="submit"
              id="submit"
              value="Log In"
              className="submit p-3 rounded-3xl mx-auto my-7 cursor-pointer text-3xl text-center text-white bg-blue"
              onClick={login}
            />
            <p className="text-center md:text-2xl texl-xl text-blue">
              <Link to="/signup">Wanna sign up instead?</Link>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
